import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {filterDate_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterDate_template";
import {filterWebsiteUser_template} from "./filterWebsiteUser_template";
import {filterTag_template} from "./filterTag_template";
import {multipleSelector_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/multipleSelector_template";

declare var ko: any;

const DEFAULT_DIMENSIONS = [
    {id: "modAuthor", name: "Mod Author"},
    {id: "game", name: "Game"},
    {id: "date", name: "Date"},
];

const DEFAULT_SELECTED_DIMENSIONS = [
    {id: "modAuthor", name: "Mod Author"},
    {id: "game", name: "Game"},
    {id: "date", name: "Date"},
];

const DEFAULT_METRICS = [
    {id: "modCount", name: "Mod Count"},
    {id: "modUploads", name: "Mod Uploads"},
    {id: "modDownloads", name: "Mod Downloads"},
    {id: "likes", name: "Likes"},
    {id: "follows", name: "Follows"},
    {id: "modComments", name: "Comments"},
    {id: "modPoints", name: "Points"},
];

export class modReport_template extends vnTemplate {

    protected dateFilter: filterDate_template;
    protected authorFilter: filterWebsiteUser_template;
    protected gameFilter: filterTag_template;
    protected dimensionFilter: multipleSelector_template;
    protected metricsFilter: multipleSelector_template;

    protected getTemplateHtml(): string {
        return /* html */`
            <div class="sub-header w-justify">
                <div class="w-left">
                    <div>${ this.dateFilter.getHtmlBuild() }</div>
                    <div class="filter-grouping">
                        <label for="mod-report-grouping">Group By</label>
                        <select id="mod-report-grouping" data-bind="value: dateGrouping">
                            <option value="daily">Daily</option>
                            <option value="weekly">Weekly</option>
                        </select>
                    </div>
                    <div>${ this.authorFilter.getHtmlBuild() }</div>
                    <div>${ this.gameFilter.getHtmlBuild() }</div>
                    <div>${ this.dimensionFilter.getHtmlBuild() }</div>
                    <div>${ this.metricsFilter.getHtmlBuild() }</div>
                </div>
            </div>

            <div class="w-filters-selected">
                <div id="filters-selected" class="filters-selected">
                    <div id="selected-authors"></div>
                    <div id="selected-games"></div>
                    <div id="selected-dimensions"></div>
                    <div id="selected-metrics"></div>
                </div>
            </div>

            <div class="list-header w-justify">
                <div class="w-left">
                    <button class="btn icon i-export" type="button"
                        data-bind="event: { click: onClickExport }, attr: { disabled: exportInProgress }, css: { 'is-disable': exportInProgress, 'is-loading': exportInProgress }">
                        Export
                    </button>
                </div>
            </div>
        `;
    }

    protected initPartial(): void {
        this.dateFilter = new filterDate_template("dateFilter", this.getTemplateViewModel(), this.caller);
        this.dateFilter.setLabel("Date Range");
        this.dateFilter.toggleClearButton(true);
        this.dateFilter.setStartPickerId("mod-report-start-date");
        this.dateFilter.setEndPickerId("mod-report-end-date");
        this.dateFilter.setDateRange(this.getFirstDayOfCurrentMonth(), this.getLastDayOfCurrentMonth());

        this.authorFilter = new filterWebsiteUser_template("authorFilter", this.getTemplateViewModel(), this.caller);
        this.authorFilter.asMultipleSelectionMode();
        this.authorFilter.setTagContainerId("selected-authors");
        this.authorFilter.setTagContainerCaption("Mod authors:");
        this.authorFilter.setPlaceholderText("Mod author");
        this.authorFilter.setUniqueIdentifier("modAuthorsFilter");

        this.gameFilter = new filterTag_template("gameFilter", this.getTemplateViewModel(), this.caller);
        this.gameFilter.asMultipleSelectionMode();
        this.gameFilter.setTagContainerId("selected-games");
        this.gameFilter.setTagContainerCaption("Games:");
        this.gameFilter.setPlaceholderText("Game");
        this.gameFilter.setIconClass("i-tag-a");
        this.gameFilter.setShowType(false);

        this.dimensionFilter = new multipleSelector_template("dimensionFilter", this.getTemplateViewModel(), this.caller);
        this.dimensionFilter.setLabel("Dimensions");
        this.dimensionFilter.setFilterContainerClass("margin-neg");
        this.dimensionFilter.setTagContainerId("selected-dimensions");
        this.dimensionFilter.setTagContainerCaption("Dimensions:");

        this.metricsFilter = new multipleSelector_template("metricsFilter", this.getTemplateViewModel(), this.caller);
        this.metricsFilter.setLabel("Metrics");
        this.metricsFilter.setFilterContainerClass("margin-neg");
        this.metricsFilter.setTagContainerId("selected-metrics");
        this.metricsFilter.setTagContainerCaption("Metrics:");
        this.initializeFilterOptions();
    }

    protected getTemplateName(): string {
        return "modReport-template";
    }

    protected getMainElementType(): string {
        return "div";
    }

    protected getMainElementClasses(): Array<string> {
        return ["w-content"];
    }

    protected buildViewModel(): any {
        const self = this;
        return {
            exportInProgress: ko.observable(false),
            dateGrouping: ko.observable("weekly"),
            onClickExport: function () {
                self.caller.onClickExport();
            }
        };
    }

    private getFirstDayOfCurrentMonth(): Date {
        const now = new Date();
        return new Date(now.getFullYear(), now.getMonth(), 1, 0, 0, 0);
    }

    private getLastDayOfCurrentMonth(): Date {
        const now = new Date();
        return new Date(now.getFullYear(), now.getMonth() + 1, 0, 23, 59, 59);
    }

    public buildDatePickerCalendar(): void {
        this.dateFilter.buildCalendar();
    }

    public getFiltersForRequest() {
        return {
            startDate: this.dateFilter.getTemplateViewModel().startDate(),
            endDate: this.dateFilter.getTemplateViewModel().endDate(),
            authors: this.authorFilter.getUsersForRequest(),
            games: this.gameFilter.getTagsForRequest(),
            dimensions: this.dimensionFilter.getSelectedItems(),
            metrics: this.metricsFilter.getSelectedItems(),
            grouping: this.getTemplateViewModel().dateGrouping(),
        };
    }

    public setAuthorSuggestions(users): void {
        this.authorFilter.setUsers(users);
    }

    public setGameSuggestions(tags): void {
        this.gameFilter.setTags(tags);
    }

    public setExportInProgress(value: boolean): void {
        this.getTemplateViewModel().exportInProgress(value);
    }

    public initializeFilterOptions(): void {
        this.dimensionFilter.setItems(DEFAULT_DIMENSIONS);
        this.dimensionFilter.setSelectedItems(DEFAULT_SELECTED_DIMENSIONS);
        this.dimensionFilter.setTags(DEFAULT_SELECTED_DIMENSIONS.map((item) => item.id), this.dimensionFilter.getItems());

        this.metricsFilter.setItems(DEFAULT_METRICS);
        this.metricsFilter.setSelectedItems(DEFAULT_METRICS);
        this.metricsFilter.setTags(DEFAULT_METRICS.map((item) => item.id), this.metricsFilter.getItems());

        this.getTemplateViewModel().dateGrouping("weekly");
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/modReport_template.ts